var map = {
	"./company/index.js": 1356
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2756;


//////////////////
// WEBPACK FOOTER
// ./src/components/app/support \.\/[^\/]+\/index\.jsx?$
// module id = 2756
// module chunks = 0